import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class MobilniZarizeniProvider extends BaseApi {
	async updateList(data: Record<string, any>) {
		return this.update(`/${DMS_MODULE}/${NAME}/Update`, data);
	}
}

export const apiProvider = new MobilniZarizeniProvider(DMS_MODULE, NAME);
